import { Container, DisplayObject } from '@tencent/alloy-renderer';

/**
 * 查找容器中匹配id的子组件
 * @param containerComponent
 * @param id
 */
export function findComponentsInContainerById(containerComponent: Container, id: string): DisplayObject[] {
    const { children } = containerComponent;
    const findArray: DisplayObject[] = [];
    children?.forEach((displayObj: DisplayObject) => {
        if (displayObj.id && displayObj.id.indexOf(id) >= 0) {
            findArray.push(displayObj);
        }
        if (displayObj instanceof Container) {
            findArray.push(...findComponentsInContainerById(displayObj, id));
        }
    });
    return findArray;
}
